export default __webpack_public_path__ + "static/media/Rerebrace of the Fallen Empire (nm).3e337abd.jpg";